// extracted by mini-css-extract-plugin
export default {"wrap":"readingActivity_wrap__ciWV0","heading":"readingActivity_heading__vaERb"};